import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const QuickActionsPanel = ({ selectedClient }) => {
  const navigate = useNavigate();

  const actions = [
    {
      id: 1,
      title: 'Manage Inventory',
      description: 'View and edit client inventory items',
      icon: 'Package',
      color: 'primary',
      route: '/client-inventory-management',
      disabled: !selectedClient
    },
    /* "Add New Item" removed per user request to enforce adding via client inventory
    {
      id: 2,
      title: 'Add New Item',
      description: 'Photograph and catalog new inventory',
      icon: 'Plus',
      color: 'success',
      route: '/add-inventory-item',
      disabled: !selectedClient
    },
    */
    {
      id: 3,
      title: 'Client Reports',
      description: 'Generate inventory status reports',
      icon: 'FileText',
      color: 'accent',
      route: '#',
      disabled: !selectedClient
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      primary: 'bg-primary/10 border-primary/20',
      success: 'bg-success/10 border-success/20',
      accent: 'bg-accent/10 border-accent/20',
      secondary: 'bg-secondary/10 border-secondary/20'
    };
    return colorMap?.[color] || colorMap?.primary;
  };

  const getIconColor = (color) => {
    const colorMap = {
      primary: 'var(--color-primary)',
      success: 'var(--color-success)',
      accent: 'var(--color-accent)',
      secondary: 'var(--color-secondary)'
    };
    return colorMap?.[color] || colorMap?.primary;
  };

  const handleActionClick = (action) => {
    if (!action?.disabled && action?.route !== '#') {
      navigate(action?.route);
    }
  };

  return (
    <div className="bg-card rounded-xl p-6 border border-border mb-6">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="Zap" size={24} color="var(--color-primary)" />
        <h2 className="text-xl font-semibold text-foreground">Quick Actions</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions?.map((action) => (
          <button
            key={action?.id}
            onClick={() => handleActionClick(action)}
            disabled={action?.disabled}
            className={`p-6 rounded-lg border transition-smooth text-left touch-target ${action?.disabled
                ? 'bg-muted/50 border-border opacity-50 cursor-not-allowed'
                : `${getColorClasses(action?.color)} hover:elevation-1 cursor-pointer`
              }`}
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${action?.disabled ? 'bg-muted' : getColorClasses(action?.color)
                }`}>
                <Icon
                  name={action?.icon}
                  size={24}
                  color={action?.disabled ? 'var(--color-muted-foreground)' : getIconColor(action?.color)}
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-semibold text-foreground mb-1">
                  {action?.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {action?.description}
                </p>
              </div>
              {!action?.disabled && (
                <Icon name="ChevronRight" size={20} color="var(--color-muted-foreground)" />
              )}
            </div>
          </button>
        ))}
      </div>
      {!selectedClient && (
        <div className="mt-4 p-4 bg-warning/5 rounded-lg border border-warning/20">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={18} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
            <p className="text-sm text-muted-foreground">
              Select a client from the sidebar to enable inventory management actions
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuickActionsPanel;